var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgCross = function SvgCross(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    role: "img"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "#FA3079",
    d: "m32.504 30.651-1.854 1.855-14.145-14.15L2.36 32.506.506 30.651l14.145-14.15L.506 2.351 2.36.496l14.145 14.15L30.65.496l1.854 1.855-14.144 14.15 14.144 14.15z"
  })));
};
export { SvgCross as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIzMyIgaGVpZ2h0PSIzMyI+Cgk8cGF0aCBmaWxsLXJ1bGU9ImV2ZW5vZGQiIGZpbGw9IiNGQTMwNzkiCgkJICBkPSJtMzIuNTA0IDMwLjY1MS0xLjg1NCAxLjg1NS0xNC4xNDUtMTQuMTVMMi4zNiAzMi41MDYuNTA2IDMwLjY1MWwxNC4xNDUtMTQuMTVMLjUwNiAyLjM1MSAyLjM2LjQ5NmwxNC4xNDUgMTQuMTVMMzAuNjUuNDk2bDEuODU0IDEuODU1LTE0LjE0NCAxNC4xNSAxNC4xNDQgMTQuMTV6Ii8+Cjwvc3ZnPgo=";